import React from 'react';
import { projects } from '../data/projects';
import ProjectCard from '../components/ProjectCard';
import Hero from '../components/Hero';
import './ProjectsList.css';

const ProjectsList: React.FC = () => {
  const sortedProjects = [...projects].sort((a, b) => {
    const rank = (p: typeof a) => p.featured ? 0 : p.status === 'active' ? 1 : 2;
    return rank(a) - rank(b);
  });

  return (
    <div className="projects-list-page">
      <Hero
        title="Our Projects"
        subtitle="Open-source tools and innovations built by our team to solve real-world problems."
      />

      <section className="projects-grid-section">
        <div className="projects-container">
          <div className="projects-grid">
            {sortedProjects.map((project) => (
              <ProjectCard key={project.id} project={project} />
            ))}
          </div>
        </div>
      </section>

      <section className="more-projects">
        <div className="more-projects-content">
          <h3>More Projects Coming Soon</h3>
          <p>We're continuously building open-source tools and solutions. Check back for updates!</p>
        </div>
      </section>
    </div>
  );
};

export default ProjectsList;
